import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { getMeasureValue } from "~/utils/getMeasureValue";
import { Emdash } from "~/components/Punctuation";
import { DataGridNumberPercentChangeComboCell } from "~/components/DataGrid/DataGridNumberPercentChangeComboCell";
import { CatalogMetricSlugs } from "~/modules/catalog/types";

export const HOLDING_ADDRESS_COUNT_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: CatalogMetricSlugs.holding_addresses_count,
    label: "Holders",
    tooltip: "Number of addresses holding the asset.",
    type: ColumnTypes.number,
    sortsOn: AssetColumns.holdingAddressesCount,
    width: 140,
    loginRequired: true,
    render: (item) => {
        const measure = getMeasureValue(item, "holding_addresses_count");

        if (measure === null || measure.val === 0) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="30d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};
